module.exports = __webpack_public_path__ + "static/media/history-icon.07808f21.jpg";